// extracted by mini-css-extract-plugin
export default {"w-layout-grid":"Grid_w-layout-grid__M9jc9","intro-grid":"Grid_intro-grid__c479i","intro-grid--variant":"Grid_intro-grid--variant__r7zaW"};